import { create } from "zustand";

const readStoredDarkMode = () => {
  if (typeof window === "undefined") return false;
  const raw = window.localStorage.getItem("isDark");
  return raw === "true" || raw === true;
};

const useThemeStore = create((set) => ({
  isDark: readStoredDarkMode(),
  setIsDark: (isDark) => set({ isDark: isDark === true || isDark === "true" }),
}));

export default useThemeStore;
